export const slug = (s) => {
  return s
      .replaceAll(' ', '_')
      .replaceAll('"', '')
      .replaceAll("'", '')
      .replaceAll("/", '-')
}